import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import AtlasV2OrganicTrafficSplineChart from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2OrganicTraffic/AtlasV2OrganicTrafficSplineChart';
import AtlasV2OrganicTrafficByTopEntity from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2OrganicTraffic/AtlasV2OrganicTrafficByTopEntity';
import AtlasV2OrganicTrafficShareChart from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2OrganicTraffic/AtlasV2OrganicTrafficShareChart';
import AtlasV2OrganicTrafficProductsSplineChart from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2OrganicTraffic/AtlasV2OrganicTrafficProductsSplineChart';
import AtlasV2OrganicTrafficKeywordSplineChart from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2OrganicTraffic/AtlasV2OrganicTrafficKeywordSplineChart';
import AtlasV2TrafficProductTable from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2TotalTraffic/AtlasV2TrafficProductTable';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';

/**
 * Atlas V2 Organic Traffic Page layout - Tab name: traffic subtab name: organicClicks
 */
export const AtlasV2OrganicTrafficPageLayout = () => {
  const { isProductEntity } = useProductEntity();
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        {/* Organic Traffic  */}
        <AtlasV2OrganicTrafficSplineChart />
        {/* Organic Traffic By Keyword */}
        <AtlasV2OrganicTrafficByTopEntity />
        {/* Share of Organic Traffic */}
        <AtlasV2OrganicTrafficShareChart />
        {/* Product with Organic Traffic */}
        {!isProductEntity && <AtlasV2OrganicTrafficProductsSplineChart />}
        {/* Keyword Count with Organic Traffic */}
        <AtlasV2OrganicTrafficKeywordSplineChart />
        {/* Organic traffic product table */}
        <AtlasV2TrafficProductTable subtab="organicClicks" />
      </Flex>
    </BasePageContainer>
  );
};
